<template>
  <div class="showMore">
    <div @click="$showMore(text)" v-if="text">
      <p class="oline_p" :style="`width:${width}`">{{text}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "showMore",
    props: {
      text:{
        default:null
      },
      width:{
        default:'auto'
      }

    },
    components: {},
    data() {
      return {

      }
    },
    created() {

    },
    methods: {},
    watch:{

    }
  }
</script>
<style scoped lang="scss">
  .showMore p{
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/showMore/showMore.vue